module.exports = __webpack_public_path__ + "static/media/(V)_MG_5931_-_Cia_Termal_Beachewear_-_Moda_Feminina.022a91a5.jpg";